export const timeslotKindExceptionAvailableForConstants = {
	TEAM: 'team',
	EMPLOYEE: 'employee',
	JOBTITLE: 'jobtitle',
};
